import React, { useContext, useEffect } from "react";
import JobTableRow from "./JobTableRow";
import _ from "lodash";
import { TableViewSelectionContext } from "../../context/TableViewSelectionContext";

const TableContextRenderer = ({ dataChanged, showJobs, jobs, requests, headers, order, field }) => {
  const { reset } = useContext(TableViewSelectionContext);
  let valueRef = "";

  useEffect(() => {
    reset();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataChanged]);

  return (
    dataChanged &&
    _.map(showJobs ? jobs : requests, (dataEntry, index) => {
      valueRef = _.get(dataEntry, "jobId", _.get(dataEntry[0], "requestSummary.requestId"));
      return (
        <JobTableRow
          key={"__job_row_" + index + "_" + valueRef}
          keyId={"__job_row_" + +index + "_" + valueRef}
          parentId={null}
          data={dataEntry}
          totalCount={-1}
          headersData={headers}
          isMultipleJobs={false}
          setSelectedJobs={null}
          selectedJobs={null}
          showJob={showJobs}
          isDraft={_.get(dataEntry[0], "status", false) === "DRAFT" ? true : false}
          status={_.get(dataEntry[0] ? dataEntry[0] : dataEntry, "status", "")}
        />
      );
    })
  );
};

export default TableContextRenderer;
